import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Button } from "../../../button";
import { getAppointmentColor, getBackgroundColor, getBorderColor, getTextColor, } from "./declarations";
export const WeekWrapper = styled.div `
  display: inline-flex;
  gap: 0.25rem;
`;
export const StyledButtonWrapper = styled.div `
  position: relative;
  .range-selection {
    ${({ isInRange, selected }) => isInRange && !selected ? "width: 40px;" : "width: 20px;"};
    height: 2.5rem;
    background: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.08);
    z-index: -7;
    position: absolute;
    ${({ paddingRight }) => (paddingRight ? "right: 0" : "left: -0.25rem")};
    ${({ paddingBoth }) => paddingBoth ? " width: 2.75rem;left: -0.25rem;" : ""};
    ${({ isInRange, selected, today }) => isInRange && (selected || today)
    ? "display: inline-block;"
    : "display: none"};
  }
  &:hover {
    button {
      border-top-right-radius: 50%;
      border-bottom-right-radius: 50%;
    }

    .range-selection {
      ${({ today }) => (today ? "width: 20px;" : "")};
    }
  }
`;
export const Appointment = styled.div `
  position: absolute;
  right: 7px;
  top: 7px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.warning};
`;
export const StyledButton = styled((props) => _jsx(Button, Object.assign({}, props))) `
  display: inline-flex;
  border-radius: 50%;
  border-color: ${({ theme }) => getBorderColor("init", theme)};
  color: ${({ theme }) => getTextColor("init", theme)};
  ${Appointment} {
    background-color: ${({ theme }) => getAppointmentColor("init", theme)};
  }
  position: relative;

  ${({ isInRange, selected, today, theme }) => isInRange && !selected && !today
    ? `
      background-color: rgba(${theme.colors.transparentBlack}, 0.08);
      border-radius: 0;
      `
    : today
        ? ``
        : ""};

  &:before {
    ${({ isInRange, selected }) => isInRange && !selected ? 'content: "";' : ""};
    width: 0.25rem;
    height: calc(100% + 2px);
    background: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.08);
    position: absolute;
    left: calc(-0.25rem - 1px);
    top: -1px;
    bottom: 0;
    z-index: -7;
  }

  &:hover {
    &:before {
      ${({ isInRange, today }) => !(isInRange && today) ? "" : "content: none;"};
    }
    ${({ today, selected }) => today && !selected ? "background-color: white;" : ""};

    &:after {
      /* ${({ today }) => (today ? 'content: "";' : "")}; */
      width: 20px;
      height: calc(100% + 2px);
      background: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.08);
      position: absolute;
      left: calc(-0.25rem - 1px);
      top: -1px;
      bottom: 0;
      z-index: -7;
    }

    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    color: ${({ theme }) => getTextColor("init", theme)};
    border-color: ${({ theme }) => getBorderColor("init", theme)};
    ${Appointment} {
      background-color: ${({ theme }) => getAppointmentColor("init", theme)};
    }
  }

  &:focus {
    ${({ selected, isInRange }) => selected && !isInRange
    ? `background: ${({ theme }) => theme.colors.grey15}`
    : ""};
  }

  &:active {
    background: ${({ theme }) => getBackgroundColor("active", theme)};
    color: ${({ theme }) => theme.colors.white};
  }

  &[tabindex="0"] {
    border-radius: 50%;
    ${({ today }) => today
    ? `border: 1px solid ${({ theme }) => theme.colors.warning};`
    : `border: 1px solid ${({ theme }) => theme.colors.primaryLight}`};
  }
`;
export const DayButtonsWrapper = styled.div `
  display: flex;
  gap: 0.25rem;
  flex-wrap: wrap;
  margin-top: 0.5rem;
  div {
    div:first-of-type {
      button:first-of-type {
        &:before {
          content: unset;
        }
      }
    }
  }
`;
